import { useEffect, useRef, useState } from 'react';
import { LockKeyhole } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useAdminAccess } from './AdminAccessProvider';
import { proshopError } from '../proshop/proshopApi';

export const AdminSignInForm = ({ onSuccess, onBusyChange }) => {
  const { signIn } = useAdminAccess();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  useEffect(() => { onBusyChange?.(busy); return () => onBusyChange?.(false); }, [busy, onBusyChange]);
  const submit = async event => {
    event.preventDefault(); if (lock.current) return;
    lock.current = true; setBusy(true); setError('');
    try { await signIn(email, password); if (mounted.current) onSuccess?.(); }
    catch (err) { if (mounted.current) setError(proshopError(err)); }
    finally { lock.current = false; if (mounted.current) { setPassword(''); setBusy(false); } }
  };
  return <form onSubmit={submit} className="space-y-5" data-testid="admin-access-form">
    <label className="course-field"><span>Admin email</span><Input type="email" required maxLength={254} autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} disabled={busy} data-testid="admin-email-input" /></label>
    <label className="course-field"><span>Admin access key</span><Input type="password" required maxLength={512} autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} disabled={busy} data-testid="admin-key-input" /></label>
    {error && <p className="course-error" role="alert" data-testid="admin-auth-error">{error}</p>}
    <Button type="submit" className="course-primary w-full" disabled={busy} data-testid="admin-access-submit"><LockKeyhole size={16} className="mr-2" />{busy ? 'Verifying…' : 'Sign in as admin'}</Button>
  </form>;
};